// extracted by mini-css-extract-plugin
export default {"siteName":"Header_siteName__UOX97"};